import { initializeSentry } from "@modules/utils/sentry";

initializeSentry();
